import { Component, Input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { getProvider } from '../../../../Common/Forms/models/control-value-accessor.model';
import { MonitoringAdvancedBooleanModel } from '../../models/monitoring-advanced-boolean.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-monitoring-expert-boolean-search',
    templateUrl: './monitoring-expert-boolean-search.component.html',
    styleUrls: ['./monitoring-expert-boolean-search.component.scss'],
    providers: [getProvider(MonitoringExpertBooleanSearchComponent)],
    animations: [
        trigger('containerState', [
            state('hidden', style({
                height: '0',
                opacity: 0,
                padding: 0
            })),
            state('visible', style({
                height: '*',
                opacity: 1,
                padding: '10px 0 10px 0'
            })),
            transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class MonitoringExpertBooleanSearchComponent implements ControlValueAccessor {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() ariaDescribedBy: string;

    queryValidationError: string = '';

    // If you change the value of this outside of write(), you must call this.onModelChange()
    expertBooleanQuery: MonitoringAdvancedBooleanModel;
    helpExpanded: boolean = false;

    public onModelChange: Function = () => {};

    public onModelTouched: Function = () => {};

    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }

    writeValue(value: any): void {
        // This is hack. For some reason, we get calls where the value is NULL, which is not something we expect
        // nor see in other 'write' functions. We have added this check to avoid not setting the value to null
        // which is shouldn't ever be.
        if (value !== null) {
            this.expertBooleanQuery = value;
        }
    }

    processQueryStringChange(event: string): void {
        this.expertBooleanQuery.filter = event.valueOf();
        this.onModelChange(this.expertBooleanQuery);
    }

    processSearchContextsChange(event: any): void {
        this.expertBooleanQuery.searchContexts = event.valueOf();
        this.onModelChange(this.expertBooleanQuery);
    }
}
